"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _mutations = require("../mutations");

var _default = function _default() {
  return {
    mutation: _mutations.IDENTITY_LOGIN_MUTATION,
    module: 'identity',
    buildVariables: function buildVariables(_ref) {
      var email = _ref.email,
          password = _ref.password,
          alias = _ref.alias,
          fingerprint = _ref.fingerprint,
          recaptchaToken = _ref.recaptchaToken;
      return {
        email: email,
        password: password,
        alias: alias,
        fingerprint: fingerprint,
        recaptchaToken: recaptchaToken
      };
    }
  };
};

exports["default"] = _default;